import { TriangleAlert } from "lucide-react";
import * as React from "react";

import { cn } from "../lib/cn";
import { Button } from "./button";

export interface ErrorStateProps {
  readonly title?: string;
  /** Sanitized, user-facing failure message. */
  readonly message: string;
  /** When provided, renders a "Try again" button. */
  readonly onRetry?: () => void;
  readonly retryLabel?: string;
  readonly className?: string;
}

/** Failure placeholder with an explicit recovery affordance. */
export function ErrorState({
  title = "Something went wrong",
  message,
  onRetry,
  retryLabel = "Try again",
  className,
}: ErrorStateProps): React.JSX.Element {
  return (
    <div
      role="alert"
      className={cn(
        "flex flex-col items-center justify-center gap-3 px-6 py-12 text-center",
        className,
      )}
    >
      <span className="bg-destructive/10 text-destructive flex size-12 items-center justify-center rounded-full">
        <TriangleAlert aria-hidden className="size-6" />
      </span>
      <div className="space-y-1">
        <p className="text-sm font-medium">{title}</p>
        <p className="text-muted-foreground max-w-sm text-sm text-balance">{message}</p>
      </div>
      {onRetry !== undefined ? (
        <Button variant="outline" size="sm" onClick={onRetry}>
          {retryLabel}
        </Button>
      ) : null}
    </div>
  );
}
